/**
 * @fileoverview Dados de configuração da aplicação
 * @module ConfigData
 * @version 1.0.0
 */

import type { Config } from "./tipos";

/**
 * Configuração principal da aplicação
 *
 * @description Centraliza todos os endpoints e configurações necessárias
 * @constant
 * @readonly
 */
export const URL: Config = {
  out: {
    API_AVATAR_URL: "https://api.uploadthing.com/v6/",
    API_AVATAR_SECRET_KEY: process.env.NEXT_PUBLIC_UPLOADTHING_SECRET_KEY ?? "",    
    API_CONTROLE_URL: "/api/controle/MovPortaria/",
  },
  in: {
    API_USER: "/api/usuario",

    API_DOCS_CONTENT: "/api/docs/docs-content",
    API_DOCS_PATHS: "/api/docs/docs-paths",

    API_PRENOTAS_PRODUTOS: "/api/prenotas/produtos",
    API_PRENOTAS_FORNECEDORES: "/api/prenotas/fornecedor",
    API_PRENOTAS_PEDIDOS: "/api/prenotas/pedido",
    API_PRENOTAS_PRE_SOLICITACAO: "/api/prenotas/preSolicitacao",
    API_CLASSIFICACAO: "/api/prenotas/classificacao",
    API_CLASSIFICACAO_PRODUTOS: "/api/prenotas/classificacao",
    API_PRENOTAS_LIST: "/api/prenotas/list",
    API_PRENOTAS_DASHBOARD: "/api/prenotas/",
    API_PRENOTAS_TIMELINE: "/api/prenotas/timeline",
    API_PRENOTAS_EDICAO: "/api/prenotas/editar",
    API_PRENOTAS_EDICAO_PROD: "/api/production/DocumentoDeEntrada/PreNotaV2",
    API_APPS: "/api/apps",
    API_LOCAL_APPS_UPLOAD: "/api/anexo/upload",

    API_FINANCEIRO_FATURAS: "/api/financeiro/faturas",
    API_FINANCEIRO_INCLUSAO: "/api/financeiro/inclusao",

    API_ANIVERSARIO: "/api/aniversariantes",
    API_AZURE_AUTH: "/api/azure/auth",
    API_PRENOTAS_ANEXOS: "/api/apps/anexos",
    API_GO: "/api/go",
    API_PRODUCTION: "/api/production",
  },
} as const;
